export default {
  default: [
    {
      path: "/development-tools",
      name: "developmentTools.view",
      component: () => import("./views/DevelopmentToolDetailsView.vue")
    }
  ]
};
